import ScheduleReportsList from '../components/ScheduleReportsList';
import ScheduleReportsHeader from '../components/ScheduleReportsHeader';
import {ScheduleReportsListWithContext} from '../context/ScheduleReportsListContext';
import {PageContainer} from '@vidazoo/ui-kit';
import theme from './theme.module.scss';

export default function ScheduleReports() {

    return (
        <ScheduleReportsListWithContext>
            <PageContainer pageTitle="Schedule Reports" className={theme.page} top={1.2}>
                <ScheduleReportsHeader/>
                <ScheduleReportsList/>
            </PageContainer>
        </ScheduleReportsListWithContext>
    );
}
